import { Reducer, createSlice } from "@reduxjs/toolkit";
import { AppDispatch } from "../state";
import { SERVER_URL } from "../../utils/server";
import { Callback } from "../../index.d";
import { toggleSessionExpired } from "../utils/uiSlice";
import { pageSizeReq } from "../../utils/constants";

export type Promotion = {
  [index: string]: any;
  cible: "BOSS" | "GROUILLEUR" | "TOUS" | "";
  code: string;
  dateDebut: string;
  dateFin: string;
  libelle?: string;
  regle: "TAUX_COMMISSION" | "CAGNOTTE" | "CAUTION" | "LIVRAISON_GRATUITE" | "";
  taux?: boolean;
  valeur: number;
};

export declare interface PromotionState {
  [index: string]: any;
}

const initialState: PromotionState = {};

export const promotionSlice = createSlice({
  initialState,
  name: "promotion",
  reducers: {
    createPromotion: (state, action) => {
      state[action.payload.id] = action.payload;
      return state;
    },
    listPromotion: (state, action) => {
      for (const obj of action.payload) {
        state[obj.id] = obj;
      }
      return state;
    },
    removePromotion: (state, action) => {
      delete state[action.payload];
      return state;
    },
    updatePromotion: (state, action) => {
      state[action.payload.id] = {
        ...state[action.payload.id],
        ...action.payload,
      };
      return state;
    },
  },
});

export const {
  createPromotion,
  listPromotion,
  removePromotion,
  updatePromotion,
} = promotionSlice.actions;

export const createAsyncPromotion =
  (data: Promotion, callback: Callback, onError: Callback) =>
  async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;
      const result = await fetch(`${SERVER_URL}promotion`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
      });

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      if (result.status === 200) {
        dispatch(listAsyncPromotion());
        callback?.();
      } else {
        onError?.();
      }
    } catch (error) {
      console.log("create promotion error", error);
      onError?.();
    }
  };

export const listAsyncPromotion =
  () => async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;

      const result = await fetch(
        `${SERVER_URL}promotion?size=${pageSizeReq}&page=1`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      const res = await result.json();
      if (res.data.length) {
        dispatch(listPromotion(res.data));
      }
    } catch (error) {
      console.log("list promotion error", error);
      // onError?.();
    }
  };

export default promotionSlice.reducer as Reducer<PromotionState>;
